import {
  SAVE_FORM_DRAFT,
  REMOVE_FORM_DRAFT,
  SET_FORM_OPEN,
  SET_FORM_CLOSED,
  UPDATE_FORM_DRAFT_TIMESTAMP,
} from "~/store/action_types";

export const saveFormDraft = (formKey, formData = {}) => {
  return {
    type: SAVE_FORM_DRAFT,
    formKey,
    formData,
  };
};

export const removeFormDraft = (formKey) => {
  return {
    type: REMOVE_FORM_DRAFT,
    formKey,
  };
};

export const updateFormDraftTimestamp = (formKey) => {
  return {
    type: UPDATE_FORM_DRAFT_TIMESTAMP,
    formKey,
  };
};

export const openForm = (formKey, id) => {
  return {
    type: SET_FORM_OPEN,
    formKey,
    id,
  };
};

export const closeForm = (formKey, id) => {
  return {
    type: SET_FORM_CLOSED,
    formKey,
    id,
  };
};
